module.exports = __webpack_public_path__ + "static/media/fb.781ee9eb.png";